import React from 'react'
import { SxProps, useTheme } from '@mui/material/styles'
import { UseFormReturn, useForm } from 'react-hook-form'
import { inputProperties } from '../../../../types/inputProperties'
import Dropdown, { ItemObject } from '../../../../base/Dropdown/Dropdown'

const defaultSx = (theme: any) => {
  return {
    categorySelectStyle: {
      height: theme.spacing(5.375),
      borderRadius: theme.spacing(),
      border: '1px solid rgba(0, 0, 0, 0.2)',
      boxShadow: '0px 2px 4px 0px rgba(0, 0, 0, 0.07)',
    },
    subtitleStyle: {
      marginBottom: '12px',
    },
  }
}

export interface CategorySelectProps {
  category: inputProperties
  items: Array<ItemObject>
  form?: UseFormReturn
  sx?: SxProps
  subtitle?: string
  width?: number
  onChange?: Function
}

const CategorySelect = (props: CategorySelectProps) => {
  const theme = useTheme()
  const { categorySelectStyle } = defaultSx(theme)

  const useFormDefault = props.form || useForm()

  const categoryProps = props.category

  return (
    <Dropdown
      sx={{ ...categorySelectStyle, ...(props.sx || {}) }}
      form={useFormDefault}
      disabled={categoryProps?.disabled}
      id={categoryProps?.id}
      items={props.items}
      label={categoryProps?.label}
      required={categoryProps?.required}
      name={categoryProps.name}
      onChange={props.onChange}
      value={categoryProps?.value}
    />
  )
}

export default CategorySelect
